import log from '../utils/log'
import _ from 'lodash'
import { BikehubMembership } from './membership.js'

// Needs to be outside of class or else it doesn't work :(
window.locationsGoogleMapsCallback = function () {
  window.bikehubLocations.init()
}

export class BikehubLocations {
  constructor () {
    this.locationMarkersRendered = false
    this.allLocations = window.bikehubLocationsSerialized
    this.activeLocationId = null
    this.rerenderListenerInitialized = false
    this.shownLocationKinds = window.initialLocationKinds
    this.setShowPremiumMapIcon()
  }

  storedViewportOrDefault () {
    const stored = bikehubMapping.storedViewport()
    // If no stored location, or stored doesn't have zoom (which means it's broken) return default
    return !stored || !stored.zoom
      ? { lat: 36.136079, lng: -119.0093237, zoom: 6 }
      : stored
  }

  iconForPoint (point) {
    if (window.showPremiumMapIcons) {
      return point.map_icon_premium
    } else {
      return point.map_icon
    }
  }

  locationForPoint (point) {
    return _.find(bikehubLocations.allLocations, ['id', point.id])
  }

  locationForMarker (marker) {
    return _.find(bikehubLocations.allLocations, ['id', marker.ourId])
  }

  setShowPremiumMapIcon () {
    window.showPremiumMapIcons = _.includes(
      this.shownLocationKinds,
      'kiosk_room'
    )
  }

  init () {
    // Add the locations mapping stuff
    bikehubMapping.page = 'locations' // assign the loaded mapping class to be the correct kind. Used by the popups
    bikehubMapping.wrapperElementID = 'locationsMap'
    if (!bikehubMapping.googleMapsLoaded()) {
      return bikehubMapping.loadMap(locationsGoogleMapsCallback)
    }
    // Set the membership page, below mapping init loop
    window.bikehubMembership = new BikehubMembership()
    bikehubMembership.init()
    // Default lat and lng
    bikehubMapping.renderMap(this.storedViewportOrDefault())
    this.renderLocationsMarkers()
    this.setRerenderFunctions()
  }

  rerenderMarkers () {
    bikehubMapping.clearMarkers({})
    bikehubLocations.addMarkerPointsForLocations()
    bikehubMapping.addMarkers({})
  }

  renderLocationsMarkers () {
    // Don't rerender locations
    if (this.locationMarkersRendered) {
      return log.debug('already rendered')
    }
    if (bikehubMapping.googleMapsLoaded()) {
      log.debug('map loaded')
      // Make marker data from the locations
      this.addMarkerPointsForLocations()
      // Then render the points
      bikehubMapping.addMarkers({})
      // bikehubMapping.addMarkers({ fitMap: true });
      return (this.locationMarkersRendered = true)
    }
    // call this again in .25 seconds, unless we returned prematurely (because things have rendered)
    log.debug('looping renderLocationsMarkers')
    setTimeout(bikehubLocations.renderLocationsMarkers, 250)
  }

  addMarkerPointsForLocations () {
    let locationsToRender = this.matchingLocations({
      kinds: this.shownLocationKinds
    })
    // Reset whether to show premium icons or not
    this.setShowPremiumMapIcon()
    log.debug(locationsToRender, window.showPremiumMapIcons)
    // return the markers from the points that are passed
    return (bikehubMapping.markerPointsToRender = locationsToRender.map(
      loc => ({
        id: loc.id,
        lat: loc.lat,
        lng: loc.lng,
        map_icon: loc.map_icon,
        map_icon_premium: loc.map_icon_premium
      })
    ))
  }

  setRerenderFunctions () {
    // We only want to set up the listeners once
    if (this.rerenderListenerInitialized) {
      return true
    }
    this.rerenderListenerInitialized = true
    // We want to store the location every time the map idles, since that's what we use to load to the correct location
    google.maps.event.addListener(bikehubMap, 'idle', function () {
      bikehubMapping.storeViewport()
    })
    // We also want to rerender the locations whenever the select kinds buttons change
    $('#selectedKinds input').on('change', function (e) {
      bikehubLocations.rerenderMarkers()
    })
  }

  markerMapPopup (point) {
    const location = this.locationForPoint(point)
    this.activeLocationId = point.id
    return `<div class="map-popup">
      <h5>${location.name} - ${location.kinds_humanized}</h5>
      <p>Address: ${location.address}
    </div>`
    // <p class="mt-3">Details: <a href="${location.details_url}">${location.details_url}</a></p>
  }

  // Simple selection of locations. Examples:
  // matchingLocations({ id: "pleasant_hill_bart_bike_station" })[0]
  // matchingLocations({ kinds: "kiosk_room" })
  matchingLocations ({ id = null, kinds = null }) {
    // Ensure that we have an array
    const kinds_array = kinds == null ? null : _.flatMap([kinds])

    return _.filter(this.allLocations, function (location) {
      if (id != null) {
        if (location.id === id) {
          return true
        }
      }
      if (kinds_array != null) {
        let matchingKind = _.find(location.kinds, function (kind) {
          return _.includes(kinds_array, kind)
        })
        return matchingKind != undefined
      }
    })
  }
}
